import { PaginationResponse } from "../../@types";
import AxiosInstance from "../../utils/axios";

export type Product = {
  id: string;
  name: string;
  slug: string;
  summary: string | null;
  description: string | null;
  thumbnailUrl: string;
  totalView: number;
  totalPurchase: number;
  category: number | null;
  categoryName?: string;
  prices: {
    minActualPrice: number | null;
    maxActualPrice: number | null;
    minDiscountPrice: number | null;
    maxDiscountPrice: number | null;
  };
  types: {
    actualPrice: number;
    discountPrice: number;
    id: string;
    productId: string;
    typeId: string;
    value: string;
    typeName: string;
    order: number;
  }[];
  images: {
    url: string;
    order: number;
    id: string;
  }[];
};

async function getProducts(
  context?: {
    signal?: AbortSignal;
  },
  params?: any
): Promise<PaginationResponse<Product>> {
  return (
    await AxiosInstance.get("/product", {
      signal: context && context.signal,
      params,
    })
  ).data.data;
}

async function getProductById(ctx: any, id: string): Promise<Product> {
  return (
    await AxiosInstance.get(`/product/${id}`, {
      signal: ctx && ctx.signal,
    })
  ).data.data;
}

async function getSuggestProductsById(
  ctx: any,
  id: string
): Promise<Product[]> {
  return (
    await AxiosInstance.get(`/product/${id}/suggest`, {
      signal: ctx && ctx.signal,
    })
  ).data.data;
}

const ProductAPI = {
  getProducts,
  getProductById,
  getSuggestProductsById,
};
export default ProductAPI;
